import React from "react";
import { FolderContainer } from "globalComponents";
import styled from "styled-components";

import NotificationsList from './components/NotificationsList.jsx'

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const NotificationsPage = () => {

    return (
        <Main>
            <FolderContainer title="Notifications">
                <NotificationsList />
            </FolderContainer>
        </Main>
    )
};

export default NotificationsPage;